import EmojiSadColoredIcon from 'components/Icons/EmojiSadColored';
import EmojiMehColoredIcon from 'components/Icons/EmojiMehColored';
import EmojiSmileColoredIcon from 'components/Icons/EmojiSmileColored';
import EmojiHappyColoredIcon from 'components/Icons/EmojiHappyColored';
import styled from '@emotion/styled/macro';
import EmojiThumbsDownColoredIcon from 'components/Icons/EmojiThumbsDownColored';
import EmojiThumbsUpColoredIcon from 'components/Icons/EmojiThumbsUpColored';
import camelCase from 'lodash/camelCase';

const getStyledIcon = (Icon, color) => styled(Icon)`
  color: ${color};
`;

const facesChoices = {
  bad: {
    Emoji: getStyledIcon(EmojiSadColoredIcon, '#F43756'),
    value: 'bad',
    color: '#F43756',
  },
  notGood: {
    Emoji: getStyledIcon(EmojiMehColoredIcon, '#FFE17D'),
    value: 'not_good',
    color: '#FFE17D',
  },
  good: {
    Emoji: getStyledIcon(EmojiSmileColoredIcon, '#A0CC7C'),
    value: 'good',
    color: '#A0CC7C',
  },
  great: {
    Emoji: getStyledIcon(EmojiHappyColoredIcon, '#4DAF4F'),
    value: 'great',
    color: '#4DAF4F',
  },
};

const facesActiveChoices = [facesChoices.bad, facesChoices.notGood, facesChoices.good, facesChoices.great];

const thumbsChoices = {
  thumbsDown: {
    Emoji: getStyledIcon(EmojiThumbsDownColoredIcon, '#F43756'),
    value: 'thumbs_down',
    color: '#FF878A',
    circleColor: '#F43756',
  },
  thumbsUp: {
    Emoji: getStyledIcon(EmojiThumbsUpColoredIcon, '#4DAF4F'),
    value: 'thumbs_up',
    color: '#5083f1',
    circleColor: '#4DAF4F',
  },
};

const thumbsActiveChoices = [thumbsChoices.thumbsDown, thumbsChoices.thumbsUp];

const getChoice = (value, emojiType = 'faces') => (emojiType === 'faces' ? facesChoices[value] : thumbsChoices[value]);
const getActiveChoices = (emojiType = 'faces') => (emojiType === 'faces' ? facesActiveChoices : thumbsActiveChoices);

const processAnalyticsForEmojis = (pulseSurveyAnalytics, pulseScale) => {
  const emojiType = pulseScale?.type;

  if (!pulseSurveyAnalytics) {
    return getActiveChoices(emojiType);
  }

  return getActiveChoices(emojiType).map(choice => ({
    ...choice,
    amount: pulseSurveyAnalytics.optionsCounts[camelCase(choice.value)],
    percentage: pulseSurveyAnalytics.optionsPercentages[camelCase(choice.value)],
  }));
};

const processAnalyticsForChart = (pulseSurveyAnalytics, getFormattedOption) => {
  const bars = [];
  const data = [];

  const optionsCount = pulseSurveyAnalytics?.optionsCounts || {};

  // eslint-disable-next-line no-restricted-syntax
  for (const [option, count] of Object.entries(optionsCount)) {
    bars.push(getFormattedOption(option));
    data.push(count);
  }

  return { bars, data };
};

const isPulseScaleTypeEmoji = (pulseScale) => ['faces', 'thumbs'].includes(pulseScale?.type);

export default {
  getChoice,
  getActiveChoices,
  processAnalyticsForEmojis,
  processAnalyticsForChart,
  isPulseScaleTypeEmoji,
};
